import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import tgApi from '../../utils/tgApi';

export const fetchTemplates = createAsyncThunk(
  'templates/fetchTemplates',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await tgApi.getTemplates(params);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || '템플릿을 불러올 수 없습니다.');
    }
  }
);

export const deleteTemplate = createAsyncThunk(
  'templates/deleteTemplate',
  async (id, { rejectWithValue }) => {
    try {
      await tgApi.deleteTemplate(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || '삭제에 실패했습니다.');
    }
  }
);

const templatesSlice = createSlice({
  name: 'templates',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearTemplatesError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTemplates.pending, (state) => { state.loading = true; })
      .addCase(fetchTemplates.fulfilled, (state, action) => { state.loading = false; state.items = action.payload; })
      .addCase(fetchTemplates.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(deleteTemplate.fulfilled, (state, action) => {
        state.items = state.items.filter((t) => t.id !== action.payload);
      });
  },
});

export const { clearTemplatesError } = templatesSlice.actions;
export default templatesSlice.reducer;
